
function removeProduct(el){
    let boton=el.parents(".card-product-main").find(".quick-add__submit")
    let variantId= el.parents(".card-product-main").find(".product-variant-id").val()
    updateCartQuantity(variantId,0).then(()=>{ 
        boton.removeClass("add-oculto")
        boton.parents(".card-product-main").find("quantity-input").find(".quantity__input").val(0)
        boton.parents(".card-product-main").find("quantity-input").addClass("add-oculto")
        boton.parents(".card-product-main").find(".quick-add__submit").removeClass("add-oculto") 
         })
}
 document.addEventListener("jQueryReady", function (e) {
$(document).on("change",".product-variant",function(e){
    let option=$(this).val()
    let id=$(this).attr("data-product-id")
    let precio=window.productosListado[Number(id)].find(((item)=>Number(item.id)==Number(option))).price/100
    $(this).parent().next().find(".product-variant-id").val(option)
    $(this).parents(".card-product-main").find(".price-item.price-item--regular").html(`$${precio}`)
  })
  
  $(document).on("click",".card-product-main .quick-add__submit",function(e){
    $(this).addClass("add-oculto"); 
    $(this).parents(".card-product-main").find(".quantity__input").val( 1)
    $(this).parents(".card-product-main").find("quantity-input").removeClass("add-oculto")
  })
  
  $(document).on("click",".card-product-main .quantity__button[name=minus],.card-product-main .quantity__button[name=plus]",
    function(){
        let el=$(this)
      el.find("span").prev().hide()
      el.find("span").addClass("visible") 
      if(el.hasClass("disabled")||(Number(el.parents(".card-product-main").find(".quantity__input").val())==0&&el.attr("name")=="minus")){
        removeProduct(el)
      }
  })
  
  
  $(document).on("change",".card-product-main .quantity__input",function(){ 
    let quantity=Number($(this).val().trim())
   let variantId= $(this).parents(".card-product-main").find(".product-variant-id").val() 
   updateCartQuantity(variantId,quantity)
  })
   
  
  function updateCartQuantity(variantId, newQuantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity
      })
    })
    .then(response => response.json())
    .then(cart => { 
      $(".cart-count-bubble span").html(cart.item_count)
    })
    .catch(error => {
      console.error('Error al actualizar el carrito:', error);
    }).finally(()=>{
      $(".spinner.visible").prev().show()
      $(".spinner.visible").removeClass("visible")
    });
  }
  
  const menuFiltrar=document.getElementById("boton-filtrar")
  const targets = document.querySelectorAll('.quantity__button[name="minus"]');
  const classToWatch = 'disabled';
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        const el = mutation.target;
        const hasClass = el.classList.contains(classToWatch);
        if (hasClass) { 
          el.classList.remove(classToWatch)
        }  
      }
    });
  });

  if(menuFiltrar){
  const observer2 = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        const el = mutation.target;
        const hasClass = el.classList.contains("menu-opening");
        if (hasClass) {  
         $(".mobile-facets__main").addClass("submenu-open")
         $(".mobile-facets__main details:first").addClass("menu-opening").attr("open",1)
        }  
      }
    });
  });
  
  observer2.observe(menuFiltrar, {
    attributes: true,
    attributeFilter: ['class']
  });
  }
  
  targets.forEach(target => {
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  });})